import { useMutation } from '@tanstack/react-query';
import { deleteProductFromProductGroup } from './apiDeleteProductFromProductGroup';
import { ErrorResponse, globalError } from '../../shared/notification/actions';
import { AxiosResponse } from 'axios';
import { invalidateLibraryManagedProductGroupProducts } from './useLibraryManagedProductGroupProducts';
import { ProductMetaData } from '../../../models/Product';
import { Article } from '../../../models/Article';
import { useTranslation } from 'react-i18next';
import { showNotification } from '../../shared/notification/toastNotification';
import { invalidateLibraryManagedProductGroupFeaturedPages } from '../../yourborrowbox/marketing/productgroups/api/useLibraryManagedProductGroupsFeaturePages';

export const useDeleteProductFromProductGroup = (productGroupId: string) => {
    const { t } = useTranslation();

    return useMutation<AxiosResponse<void>, ErrorResponse, Pick<ProductMetaData & Article, 'id' | 'title'>>(
        product =>
            deleteProductFromProductGroup({
                productGroupId,
                product
            }),
        {
            onSuccess: (_, product) => {
                invalidateLibraryManagedProductGroupProducts(productGroupId).then();
                invalidateLibraryManagedProductGroupFeaturedPages().then();

                showNotification(
                    t('notifications.getMessageFromActionProductGroup.remove', { productTitle: product.title })
                );
            },
            onError: error => {
                globalError(error);
            }
        }
    );
};
